<template>
  <v-navigation-drawer
    clipped
    fixed
    permanent
    :disable-route-watcher="true"
    stateless
    :width="250"
    :mini-variant.sync="mini"
    v-model="drawerOpen"
    app>
    <v-list>
      <v-list-tile avatar
                   tag="div">
        <v-list-tile-avatar>
          <img :src="$app.imageUrl($auth.user().avatar)">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-sub-title><b>{{$auth.user().name}}</b></v-list-tile-sub-title>
          <v-list-tile-sub-title>{{$auth.user().email}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-list dense>
      <template v-for="(item,index) in items">
        <!--When the item is group-->
        <v-list-group
          v-if="item.group"
          v-model="item.model"
          :key="index"
          :append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_right'"
          :prepend-icon="item.icon">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="(child, i) in item.children"
            :key="i"
            :to="{name: child.route, params: child.params}">
            <v-list-tile-action v-if="child.icon">
              <!--<v-icon>{{ child.icon }}</v-icon>-->
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ child.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <!--When the item has children-->
        <v-list-group
          v-else-if="item.children"
          v-model="item.model"
          :key="index"
          :append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_right'"
          :prepend-icon="item.icon">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="(child, i) in item.children"
            :key="i"
            :to="{name: item.route, params: child.params}">
            <v-list-tile-action v-if="child.icon">
              <!--<v-icon>{{ child.icon }}</v-icon>-->
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ child.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <!--When item has no children-->
        <v-list-tile v-else :key="index" :to="{name: item.route}">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--<v-list-tile :to="item.route"
                     :key="index">
          <v-list-tile-action>
            <v-badge overlap
                     small
                     color="accent"
                     v-if="item.pendingApprovals > 0">
              <span slot="badge">{{item.pendingApprovals}}</span>
              <v-icon>{{item.icon}}</v-icon>
            </v-badge>
            <v-icon v-else>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import EventBus from '../event-bus'
  import Base from './Base.vue'

  export default {
    extends: Base,
    name: 'drawer',
    data () {
      return {
        drawerOpen: true,
        mini: false,
        items: [
          /* {icon: 'dashboard', title: 'Dashboard', route: 'dashboard', pendingApprovals: 0},
          {icon: 'schedule', title: 'Subscriptions', route: 'subscriptions', pendingApprovals: 0},
          {icon: 'date_range', title: 'Appointments', route: 'appointments', pendingApprovals: 0},
          {icon: 'folder', title: 'Documents', route: 'documents'},
          {icon: 'shopping_cart', title: 'Shopping', route: 'shopping', pendingApprovals: 0},
          {icon: 'shopping_basket', title: 'Orders', route: 'orders', pendingApprovals: 0},
          {icon: 'computer', title: 'IT Services', route: 'it', pendingApprovals: 0},
          {icon: 'build', title: 'Repair Services', route: 'repairs', pendingApprovals: 0},
          {icon: 'local_shipping', title: 'Courier', route: 'courier', pendingApprovals: 0},
          {icon: 'group', title: 'Users', route: 'users', pendingApprovals: 0},
          {icon: 'group_work', title: 'Departments', route: 'departments', pendingApprovals: 0},
          {icon: 'person', title: 'My Profile', route: 'profile', pendingApprovals: 0} */
        ]
      }
    },
    methods: {
      refresh () {
        this.axios.get('drawerItems')
          .then(response => {
            this.$app.log(response)
            this.items = []
            this.items = this.items.concat(response.data.data)
          })
          .catch(error => {
            this.$app.log(error)
          })
      }
    },
    mounted () {
      let that = this
      EventBus.$on(this.$actions.clickedToolbarSideIcon, function () {
        that.mini = !that.mini
      })
      EventBus.$on(this.$actions.placedOrder, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.addedDelivery, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.addedAppointment, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.requestedService, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.approved, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.rejected, function () {
        that.refresh()
      })
      EventBus.$on(this.$actions.addedSubscription, function () {
        that.refresh()
      })
      this.refresh()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Drawer.vue